import ThirdPartyLoyalty from './ThirdPartyLoyalty'
import ThirdPartyLoyaltySignUpMessage from './ThirdPartyLoyaltySignUpMessage'
import ThirdPartyLoyaltyTerms from './ThirdPartyLoyaltyTerms'

export { ThirdPartyLoyaltySignUpMessage, ThirdPartyLoyaltyTerms }

export default ThirdPartyLoyalty
